<template>
    <OrderedListRecurring row="2" :list="$tm('page.apix_drive.data.settings')">
        <template v-slot:default="props">
            <img :src="images['img' + (props.index + 1)]" class="image_list" />
        </template>
    </OrderedListRecurring>
</template>

<script setup>
import OrderedListRecurring from "@/components/Recurring/OrderedListRecurring.vue";
import img1 from "@/assets/apix-drive/data/sett-1.png";
import img2 from "@/assets/apix-drive/data/sett-2.png";
import img3 from "@/assets/apix-drive/data/sett-3.png";
import img4 from "@/assets/apix-drive/data/sett-4.png";
import img5 from "@/assets/apix-drive/data/sett-5.png";
import img6 from "@/assets/apix-drive/data/sett-6.png";
import img7 from "@/assets/apix-drive/data/sett-7.png";
import img8 from "@/assets/apix-drive/data/sett-8.png";
import img9 from "@/assets/apix-drive/data/sett-9.png";
import img10 from "@/assets/apix-drive/data/sett-10.png";

const images = { img1, img2, img3, img4, img5, img6, img7, img8, img9, img10 };
</script>

<style lang="scss" scoped>
@use "@/styles/pages/instruction.scss";

.image_list {
    margin: 15px 0;
    width: 100%;
    /* border-radius: 11px; */
}
</style>
